import { GlobalVariables } from "../GlobalVariables";
import { gsap } from "../LibrariesImport";

export default class Page404 {

  static init() {
    this.imagesAnimation();
  }

  static imagesAnimation() {
    const root = document.querySelector(".error-page");
    if (!root) return;
    const images = [];
    root.querySelectorAll(".medias img").forEach((image) => {
      images.push(image.getAttribute("src"));
    });
    if (images.length === 0) return;

    let incr = 0,
      oldIncrX = 0,
      oldIncrY = 0,
      resetDist = window.innerWidth / 6;

    this.indexImg = 0;

    root.addEventListener(
      "mousemove",
      (e) => {
        oldIncrX = e.clientX;
        oldIncrY = e.clientY;
      },
      { once: true }
    );

    root.addEventListener("mousemove", (e) => {
      const valX = e.clientX;
      const valY = e.clientY;

      incr += Math.abs(valX - oldIncrX) + Math.abs(valY - oldIncrY);

      if (incr > resetDist) {
        incr = 0;

        const rootRect = root.getBoundingClientRect();
        const x = valX - rootRect.left;
        const y = valY - rootRect.top;

        this.createMedia(x, y, valX - oldIncrX, valY - oldIncrY, images, root);
      }

      oldIncrX = valX;
      oldIncrY = valY;
    });
  }

  static createMedia(x, y, deltaX, deltaY, images, root) {
    const image = document.createElement("img");
    image.setAttribute("src", images[this.indexImg]);
    image.setAttribute("draggable", "false");

    image.style.position = "absolute";
    image.style.zIndex = "10";
    image.style.transformOrigin = "center center";
    image.style.userSelect = "none";
    image.style.pointerEvents = "none";

    root.appendChild(image);

    const tl = gsap.timeline({
      onComplete: () => {
        if (image.parentNode) {
          image.parentNode.removeChild(image);
          tl.kill();
        }
      },
    });

    tl.fromTo(
      image,
      {
        left: x,
        top: y,
        xPercent: -50,
        yPercent: -50,
        scaleX: 1.3,
        scaleY: 1.3,
        rotation: (Math.random() - 0.5) * 20,
      },
      {
        scaleX: 1,
        scaleY: 1,
        ease: "elastic.out(2, 0.6)",
        duration: 0.6,
      }
    );

    tl.to(
      image,
      {
        left: "+=" + deltaX * 4,
        top: "+=" + deltaY * 4,
        rotation: (Math.random() - 0.5) * 20,
        ease: "power4.out",
        duration: 1.5,
      },
      0
    );

    tl.to(image, {
      duration: 0.3,
      scale: 0.5,
      delay: 0.1,
      ease: "back.in(1.5)",
    });

    this.indexImg = (this.indexImg + 1) % images.length;
  }
}
